import { Helmet } from "react-helmet-async";
import { createContext, useContext } from "react";

const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY;

const GoogleAnalytics = () => {
    if (!GOOGLE_ANALYTICS_KEY) {
        return <></>
    }

    return (
        <Helmet>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_KEY}`} />
        </Helmet>
    );
};

let GtagContext = createContext(null);

const useGTag = () => {
    return useContext(GtagContext);
}

const GTagProvider = ({ children }) => {

    let gtag;
    if (GOOGLE_ANALYTICS_KEY) {
        window.dataLayer = window.dataLayer || [];
        gtag = function() {window.dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', GOOGLE_ANALYTICS_KEY, {
            send_page_view: false
        });
    } else {
        gtag = () => {};
    }

    return <GtagContext.Provider value={gtag}>{children}</GtagContext.Provider>;
}

export {
    useGTag,
    GTagProvider,
}
export default GoogleAnalytics;
